import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

export const ExpandModal = ({
  isOpen,
  title,
  onClose,
  children,
}: PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  title: string;
}>) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent height="80%">
        <ModalHeader color="navyBlue.500">{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};
